import { type Auth, browserSessionPersistence, initializeAuth, signInWithCustomToken } from 'firebase/auth';

import { getFirebaseToken } from '@/services/api/oauth2/firebase';
import firebaseApp from './app';

let instance: Auth | undefined;

export function initializeFirebaseAuth(): Auth {
  if (instance) return instance;

  instance = initializeAuth(firebaseApp, {
    persistence: browserSessionPersistence,
  });

  return instance;
}

export const getFirebaseAuth = (): Auth => {
  if (!instance) {
    throw new Error('Firebase auth not initialized');
  }

  return instance;
};

/** Non-throwing variant for call sites that must also work signed-out or before initialization. */
export const getFirebaseAuthInstance = (): Auth | undefined => instance;

export async function signInWithToken(): Promise<void> {
  if (!instance) {
    throw new Error('Firebase auth not initialized');
  }

  const { access_token: accessToken } = await getFirebaseToken();
  if (!accessToken) {
    throw new Error('No access token found');
  }

  await signInWithCustomToken(instance, accessToken);
}
